import _sfc_main from "./component-library162.mjs";
import "./component-library163.mjs";
import normalizeComponent from "./component-library92.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _vm.pages && _vm.pages.length > 1 ? _c("nav", { staticClass: "dot-pagination", attrs: { "role": "navigation", "aria-label": _vm.ariaLabel } }, [_c("ul", { staticClass: "dot-pagination__container" }, _vm._l(_vm.pages, function(page, key) {
    return _c("li", { key, staticClass: "dot-pagination__entry" }, [_c(_setup.LinkButton, { staticClass: "dot-pagination__link", class: { "dot-pagination__link--active": page.active }, attrs: { "tag": "button", "type": "button", "icon-only": "", "outline": "", "aria-label": _setup.ariaLabelForPageNumber(_vm.pages, page), "aria-current": page.active ? "page" : void 0, "title": `${_vm.prefix} ${page.number + 1}` }, on: { "click": function($event) {
      return _vm.$emit("update", page.number);
    } } })], 1);
  }), 0)]) : _vm._e();
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "06eb67a7",
  null,
  null
);
const DotPagination = __component__.exports;
export {
  DotPagination as default
};
